// extracted by mini-css-extract-plugin
module.exports = {"all_colors":"AvailableColors_all_colors__3TEVU","single_color":"AvailableColors_single_color__1T5KA"};